{
  "aiGeneratedAnswer": "Tehisintellekti loodud vastus",
  "allCategories": "Kõik kategooriad",
  "appliedFiltersToCurrentSearch": "Rakendatud filtrid praegusele otsingule",
  "apply": "Rakendama",
  "applyFilters": "Rakenda filtrid",
  "autocompleteOptionsFound_one": "Leiti {{count}}{{label}} automaatse täitmise valik.",
  "autocompleteOptionsFound_other": "Leiti {{count}}{{label}} automaatse täitmise valikut.",
  "autocompleteSuggestion": "automaatse täitmise soovitus: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "Leiti {{count}} automaatse täitmise soovitus.",
  "autocompleteSuggestionsFound_other": "Leiti {{count}} automaatse täitmise soovitust.",
  "basedOnYourDevice": " (põhineb sinu seadmel)",
  "basedOnYourInternetAddress": " (põhineb sinu internetiaadressil)",
  "categoriesText_one": "Järgmine kategooria andis tulemusi päringu jaoks – <strong>{{query}}</strong>",
  "categoriesText_other": "Järgmised kategooriad andsid tulemusi päringu jaoks – <strong>{{query}}</strong>",
  "clearAll": "Puhastama kõik",
  "clearMinAndMax": "Tühjenda miinimum ja maksimum",
  "clearTheRangeToSelectOptions": "Valikute valimiseks tühjendage vahemik.",
  "clearTheSearchBar": "Tühjendage otsinguriba",
  "conductASearch": "Otsingut tegema",
  "currentLocation": "Praegune asukoht",
  "didYouMean": "Kas mõtlesite <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Kui automaattäite tulemused on saadaval, kasuta üles-/allanooleid eelvaateks ja Enterit valimiseks.",
  "feedback": "Tagasiside",
  "filterGroupSearchInputLabel": "Otsi {{title}} valikute seast",
  "invalidRange": "Kehtetu vahemik",
  "max": "Maks",
  "min": "Min",
  "navigateToTheNextResultsPage": "Liikuge järgmisele tulemuste lehele",
  "navigateToThePreviousResultsPage": "Liikuge eelmise tulemuste lehele",
  "noAutocompleteOptionsFound": "0 leitud automaatse täitmise valikud.",
  "noAutocompleteSuggestionsFound": "0 leitud automaatse täitmise ettepanekuid.",
  "noResultsFoundIn": "Tulemusi ei leitud kategoorias {{currentVerticalLabel}}.",
  "paginationPage": "leht {{pageNumber}}",
  "pagination": "Lehekülgede navigeerimine",
  "readMoreAbout": "Loe rohkem: <a>{{name}}</a>",
  "recentSearch": "hiljutine otsing: {{query}}",
  "recentSearchesFound_one": "Leiti {{count}} hiljutine otsing.",
  "recentSearchesFound_other": "Leiti {{count}} hiljutist otsingut.",
  "removeFilter": "Eemalda filter „{{displayName}}”",
  "resultPreview": "tulemuse eelvaade: {{value}}",
  "resultPreviewsFound_one": "Leiti {{count}} tulemuse eelvaade.",
  "resultPreviewsFound_other": "Leiti {{count}} tulemuse eelvaateid.",
  "resultsCountText_one": "{{count}} tulemust",
  "resultsCountText_other": "{{count}} tulemust",
  "resultsCountWithPaginationText": "{{paginateStart}} – {{paginateEnd}} / {{resultsCount}} tulemust",
  "searchHere": "Otsige siit…",
  "showingAllInstead": "Näidatakse hoopis kõiki kategooriaid {{currentVerticalLabel}}.",
  "showLess": "Näita vähem",
  "showMore": "Näita rohkem",
  "sources_one": "Allikas",
  "sources_other": "Allikad ({{krahv}})",
  "submitSearch": "Otsingut esitama",
  "suggestionResultsCount_one": "{{label}} – {{count}} tulemus",
  "suggestionResultsCount_other": "{{label}} – {{count}} tulemust",
  "thankYouForYourFeedback": "Täname teie tagasiside eest!",
  "thisAnsweredMyQuestion": "See vastas minu küsimusele",
  "thisDidNotAnswerMyQuestion": "See ei vastanud minu küsimusele",
  "unselectAnOptionToEnterInARange": "Valiku tühistamiseks sisestage vahemik.",
  "updateYourLocation": "Värskendage oma asukohta",
  "useCurrentLocation": "Kasuta praegust asukohta",
  "useMyLocation": "Kasuta minu asukohta",
  "viewAll": "Vaata kõiki",
  "viewDetails": "Vaadake üksikasju"
}
